<section *transloco="let transloco" class="payment-form__gift">
  <div class="form-wrapper">
    <form id="iframes" action="" method="GET" class="">

      <div class="form-row card-number">
        <index-text-input
          #indexCardNumber
          label="{{ transloco('CardNumber') }}"
          input-id="inputCardNumber"
          name="card-number"
          maxlength="19"
          ngDefaultControl
          [(ngModel)]="this.paymentData.PaymentReference"
        ></index-text-input>
      </div>

      <div class="form-row card-pin">
        <index-text-input
          #indexCardPin
          label="{{ transloco('Pin') }}"
          input-id="inputPin"
          name="pin"
          maxlength="8"
          ngDefaultControl
          [(ngModel)]="this.paymentData.CardPIN"
        ></index-text-input>
      </div>

      <div class="form-row amount">
        <index-text-input
          #indexRequestedAmount
          label="{{ transloco('Amount') }}"
          input-id="inputAmount"
          name="amount"
          max="{{balanceDueFixedPointFormat}}"
          maxlength="10"
          ngDefaultControl
          [(ngModel)]="this.paymentData.RequestedAmount"
        ></index-text-input>
      </div>

      <index-button (click)="handlePayClick()" type="primary" size="full">{{ transloco('Pay') }}</index-button>
    </form>
  </div>
</section>
